import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { openProject, ProviderErrorResponse } from '@apis/projects';
import { writeLastSiteId } from '@utils/lastSite';
import { setWorkingSiteSuccess } from '@store/slices/site.slice';

export function useOpenMonitor() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return useCallback(
    async (siteId: string) => {
      try {
        // The portfolio card id is the D-ORCA siteId (the app-wide join key).
        // openProject resolves the Site by id (resolve-only — no find-or-create).
        const workingSite = await openProject(siteId);
        dispatch(setWorkingSiteSuccess({ workingSite }));
        writeLastSiteId(workingSite.siteId);
        navigate(`/monitor/${encodeURIComponent(workingSite.siteId)}`);
      } catch (err) {
        if (err instanceof ProviderErrorResponse) {
          // PortfolioPage already gates on this for the page-level fetch, so
          // reaching this branch means the provider was disconnected between
          // the portfolio load and the click — push the user to reconnect.
          navigate(`/connect/${err.provider}`);
          return;
        }
        throw err;
      }
    },
    [dispatch, navigate],
  );
}
